import { render, staticRenderFns } from "./TentangKami.vue?vue&type=template&id=66a667f8&scoped=true"
import script from "./TentangKami.vue?vue&type=script&lang=js"
export * from "./TentangKami.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a667f8",
  null
  
)

export default component.exports